import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { wizardError } from '../actions/wizard';

import { getUserInformation } from '../utils/api';

import { USER_SET_USER } from '../constants/actionTypes';

export const setUserInfo = userInfo => ({
  type: USER_SET_USER,
  userInfo,
});

async function parseUserInformation(response) {
  const userInformation = {};

  const userInformationJson = await response.json();
  if (
    userInformationJson &&
    userInformationJson.groups &&
    Array.isArray(userInformationJson.groups) &&
    userInformationJson.groups.length > 0
  ) {
    userInformation.groups = userInformationJson.groups;
    userInformation.roles = userInformationJson.roles || [];
    userInformation.isRoot =
      userInformationJson.accessScope &&
      userInformationJson.accessScope === 'Root';
  } else {
    return null;
  }

  return userInformation;
}

export const getUserInfo = () => async dispatch => {
  dispatch(showLoading());
  try {
    const response = await getUserInformation();
    dispatch(hideLoading());

    if (response.status === 200) {
      const userInfo = await parseUserInformation(response);
      if (userInfo === null) {
        dispatch(wizardError({ title: 'errors.user_groups_not_found' }));
      } else {
        dispatch(setUserInfo(userInfo));
      }
    } else if (response.status === 401) {
      dispatch(
        wizardError({
          title: 'errors.user_has_no_organizations',
          hint: 'errors.contact_administrators_hint',
        })
      );
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    dispatch(hideLoading());
    console.error(error);
    dispatch(
      wizardError({
        title: error.message,
      })
    );
  }
};
